import { lazy, Suspense, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { LoadingSpinner } from '@/components/ui/loading-spinner.tsx';
import axios from 'axios';

const Markdown = lazy(() => import('markdown-to-jsx'));

const loader = document.querySelector('.loader-container')!;
const hideLoader = () => loader.classList.add('loader--hide');

// eslint-disable-next-line react-refresh/only-export-components
export const useMarkdownContentQuery = (
  { enabled }: { enabled?: boolean } = { enabled: true }
) => {
  return useQuery({
    queryKey: ['markdownContent', 'notes-512316664'],
    queryFn: async () => {
      try {
        const response = await axios.get('/media/release-notes/notes-512316664.md', {
          responseType: 'text',
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    retry: 1,
    enabled,
  });
};

const ReleaseNotesPage = () => {
  const { data: markdownContent, isLoading } = useMarkdownContentQuery();

  useEffect(() => {
    hideLoader();
  }, []);

  return (
    <div className="flex min-h-svh flex-col justify-between gap-12 pb-6 sm:px-6">
      <main className="mx-auto flex min-h-svh w-full max-w-[1400px] bg-white px-4 pb-8 sm:mt-20 sm:min-h-[calc(100svh-80px)]">
        <div className="mx-auto mt-8 flex max-w-[960px] flex-col gap-4">
          <h1 className="text-4xl font-bold">Release Notes</h1>

          <section className="prose prose-img:my-8 prose-h2:nth-[n+2]:border-t-2 prose-h2:pt-4 max-w-full">
            {isLoading ? (
              <div className="mt-16 flex items-center justify-center">
                <LoadingSpinner className="size-18" />
              </div>
            ) : markdownContent ? (
              <Suspense
                fallback={
                  <div className="mt-16 flex items-center justify-center">
                    <LoadingSpinner className="size-18" />
                  </div>
                }
              >
                <Markdown>{markdownContent}</Markdown>
              </Suspense>
            ) : (
              'No available release notes.'
            )}
          </section>
        </div>
      </main>
    </div>
  );
};

export default ReleaseNotesPage;
